import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ForwardIcon from '@mui/icons-material/Forward';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Card, CardContent, Checkbox, FormControlLabel, Stack, TextField } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Fade from '@mui/material/Fade';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';

export const StartupViewQuery: React.FunctionComponent<any> = ({
  queryKeys,
  queryType,
  totalFieldQueries,
  totalSectionQueries,
  fieldQueries,
  setQueryType,
  perDisable,
  expanded,
  handleChangeAccordion,
  anchorEl,
  openMore,
  handleClick,
  handleCloseMore,
  resTexts,
  setResTexs,
  sendQueryRes,
  handleTextChange,
  setDeleteType,
  handleDialoBox,
  currentId,
  setCurrentId,
  handleForwardDialogBox,
  setConfirmDailog,
  setResloveQueryId,
  handleRespondAlFieldQueries,
  handleRespondAllSectionQueries,
  respondFieldQueries,
  respondSectionQueries
}) => {
  const { checkPermission } = usePermissionWrapper();
  return (
    <Grid container>
      <Grid container spacing={0} mb={2}>
        <Grid item md={12}>
          <h2>{queryType == 'ALL' || queryType == 'Forward' ? 'All Queries' : 'Field Query'}</h2>
        </Grid>
      </Grid>
      {(queryType == 'ALL' || queryType == 'Forward') && (
        <Grid container>
          <Grid md={12}>
            <Box sx={{ mb: 2 }}>
              <Grid container>
                <Grid md={12}>
                  <Typography variant="h6" component="div" sx={{ mb: 1 }} className="h6-fs16">
                    Section Queries ({totalSectionQueries})
                  </Typography>
                </Grid>
              </Grid>
              {fieldQueries
                ? fieldQueries.map((queryObj: any) => {
                    if (
                      (queryObj.query.report_query_type == 'Section' ||
                        queryObj.query.report_query_type == 'Forward') &&
                      queryObj.query.report_section_name == queryKeys.report_section_name
                    ) {
                      return (
                        <Grid container key={queryObj.query.id}>
                          <Grid md={12}>
                            <Card className="query-card">
                              <CardContent>
                                <Grid container sx={{ pb: 2 }}>
                                  <Grid md={8} className="name-section">
                                    <AccountCircleIcon />
                                    {queryObj.query.created_by}
                                    <span>
                                      {new Date(queryObj.query.created_on)
                                        .toLocaleDateString('en-US', {
                                          hour: 'numeric',
                                          minute: '2-digit',
                                          hour12: true
                                        })
                                        .replace(/,/g, '')}
                                    </span>
                                    <Chip
                                      label={`${queryObj.query.report_query_type} Query`}
                                      color="success"
                                      size="small"
                                    />
                                  </Grid>
                                  <Grid md={4} className="more-section" display="flex" justifyContent="flex-end">
                                    <Button
                                      disabled={
                                        queryObj.query.report_is_opened == false ||
                                        !perDisable ||
                                        !(
                                          (queryKeys?.report_category === 'SQREPT' ||
                                            queryKeys?.report_category === 'SUSIVRT') &&
                                          !checkPermission('view_sq_report_after_submit')
                                        ) ||
                                        !(
                                          checkPermission('update_sq_report') &&
                                          checkPermission('update_query_tuda_sq_report')
                                        )
                                      }
                                      className="grey-btn "
                                      onClick={() => {
                                        (queryKeys?.report_category === 'SQREPT' ||
                                          queryKeys?.report_category === 'SUSIVRT') &&
                                        !checkPermission('view_sq_report_after_submit')
                                          ? setConfirmDailog(true)
                                          : setConfirmDailog(false);
                                        setResloveQueryId(queryObj.query.id);
                                      }}
                                    >
                                      {queryObj.query.report_is_opened == false ? (
                                        <CheckCircleIcon sx={{ fill: '#41B487 !important' }} />
                                      ) : (
                                        <CheckCircleOutlineIcon />
                                      )}
                                    </Button>

                                    <div>
                                      {(queryKeys?.report_category === 'SQREPT' &&
                                        !checkPermission('view_sq_report_after_submit')) ||
                                      checkPermission(
                                        queryKeys?.report_category === 'SQREPT' ||
                                          queryKeys?.report_category === 'SUSIVRT'
                                          ? queryKeys?.report_category === 'SQREPT'
                                            ? 'raise_query_sq_report'
                                            : queryKeys?.report_category === 'SUSIVRT'
                                            ? 'raise_query_siv_report'
                                            : ''
                                          : ''
                                      ) ? (
                                        <Button
                                          disabled={
                                            queryObj.query.report_is_opened == false ||
                                            (queryKeys?.report_category === 'SQREPT' &&
                                              checkPermission('view_sq_report_after_submit'))
                                          }
                                          id="fade-button"
                                          aria-controls={openMore ? 'fade-menu' : undefined}
                                          aria-haspopup="true"
                                          aria-expanded={openMore ? 'true' : undefined}
                                          onClick={e => {
                                            setCurrentId(queryObj.query.report_section_query_id_v);
                                            handleClick(e);
                                          }}
                                          className="grey-btn"
                                        >
                                          <MoreHorizIcon />
                                        </Button>
                                      ) : (
                                        <></>
                                      )}
                                      <Menu
                                        id={queryObj.query.report_section_query_id_v}
                                        MenuListProps={{
                                          'aria-labelledby': 'fade-button'
                                        }}
                                        anchorEl={anchorEl}
                                        open={openMore && currentId == queryObj.query.report_section_query_id_v}
                                        onClose={handleCloseMore}
                                        TransitionComponent={Fade}
                                        className="remove-menu"
                                      >
                                        {(queryKeys?.report_category === 'SQREPT' &&
                                          !checkPermission('view_sq_report_after_submit')) ||
                                        checkPermission(
                                          queryKeys?.report_category === 'SQREPT' ||
                                            queryKeys?.report_category === 'SUSIVRT'
                                            ? queryKeys?.report_category === 'SQREPT'
                                              ? 'delete_query_sq_report'
                                              : queryKeys?.report_category === 'SUSIVRT'
                                              ? 'delete_query_siv_report'
                                              : ''
                                            : ''
                                        ) ? (
                                          <MenuItem
                                            onClick={() => {
                                              setDeleteType('Section');
                                              handleDialoBox(queryObj.query.report_section_query_id_v);
                                            }}
                                          >
                                            <DeleteIcon /> Remove
                                          </MenuItem>
                                        ) : (
                                          <></>
                                        )}
                                        {(queryKeys?.report_category === 'SQREPT' &&
                                          !checkPermission('view_sq_report_after_submit')) ||
                                        checkPermission(
                                          queryKeys?.report_category === 'SQREPT' ||
                                            queryKeys?.report_category === 'SUSIVRT'
                                            ? queryKeys?.report_category === 'SQREPT'
                                              ? 'raise_query_sq_report'
                                              : queryKeys?.report_category === 'SUSIVRT'
                                              ? 'raise_query_siv_report'
                                              : ''
                                            : ''
                                        ) ? (
                                          <MenuItem
                                            onClick={() => {
                                              setQueryType('Forward');
                                              handleForwardDialogBox(
                                                queryObj.query.report_section_query_id_v,
                                                queryObj.query.report_send_to,
                                                queryObj.query.id
                                              );
                                            }}
                                          >
                                            <ForwardIcon />
                                            Forward
                                          </MenuItem>
                                        ) : (
                                          <></>
                                        )}
                                      </Menu>
                                    </div>
                                  </Grid>
                                  <Grid md={12}>
                                    <span className="sub-text">ID: {queryObj.query.report_section_query_id_v}</span>
                                    <span className="sub-text">Section: {queryObj.query.report_section_name}</span>
                                    <span className="sub-text">
                                      {queryObj.query.report_forward_to != '' ? 'Initially Sent To' : 'Send To'}:{' '}
                                      {queryObj.query.report_send_to}
                                    </span>
                                    {queryObj.query.report_forward_to != '' && (
                                      <span className="sub-text">Forwarded To: {queryObj.query.report_forward_to}</span>
                                    )}
                                    <span className="sub-text">Message: {queryObj.query.report_comment}</span>
                                  </Grid>
                                </Grid>

                                <Grid container>
                                  <Grid md={12}>
                                    <Accordion
                                      expanded={expanded === queryObj.query.report_section_query_id_v}
                                      onChange={handleChangeAccordion(queryObj.query.report_section_query_id_v)}
                                      className="CustomAccordion-AH"
                                    >
                                      {(queryKeys?.report_category === 'SQREPT' &&
                                        !checkPermission('view_sq_report_after_submit')) ||
                                      checkPermission(
                                        queryKeys?.report_category === 'SQREPT' ||
                                          queryKeys?.report_category === 'SUSIVRT'
                                          ? queryKeys?.report_category === 'SQREPT'
                                            ? 'respond_query_sq_report'
                                            : queryKeys?.report_category === 'SUSIVRT'
                                            ? 'respond_query_siv_report'
                                            : ''
                                          : ''
                                      ) ? (
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel2bh-content"
                                          id="panel2bh-header"
                                        >
                                          <Box>
                                            <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center', mb: 1 }}>
                                              <Typography variant="h6" component="div">
                                                {queryObj.responses && queryObj.responses.length} COMMENT
                                                {queryObj.responses && queryObj.responses.length > 1 ? 'S' : ''}
                                              </Typography>
                                            </Stack>
                                          </Box>
                                        </AccordionSummary>
                                      ) : (
                                        <></>
                                      )}
                                      <AccordionDetails>
                                        <Grid container>
                                          {queryObj.responses &&
                                            queryObj.responses.map((res: any) => {
                                              return (
                                                <div key={res.id}>
                                                  <Grid md={12} className="name-section" sx={{ pl: 2 }}>
                                                    <AccountCircleIcon /> {res.created_by}
                                                    <span>
                                                      {' '}
                                                      {new Date(res.created_on)
                                                        .toLocaleDateString('en-US', {
                                                          hour: 'numeric',
                                                          minute: '2-digit',
                                                          hour12: true
                                                        })
                                                        .replace(/,/g, '')}
                                                    </span>
                                                  </Grid>
                                                  <Grid md={12} sx={{ pl: 2 }}>
                                                    <span className="sub-text">{res.query_response}</span>
                                                  </Grid>
                                                </div>
                                              );
                                            })}

                                          <Grid container className="action-section">
                                            <Grid md={12}>
                                              <FormControl fullWidth margin="normal">
                                                <TextField
                                                  disabled={queryObj.query.report_is_opened == false}
                                                  error={resTexts[queryObj.query.id] == ''}
                                                  helperText={resTexts[queryObj.query.id] == '' ? 'Required!' : ' '}
                                                  id="standard-disabled"
                                                  label="Response"
                                                  variant="standard"
                                                  inputProps={{ maxLength: 200 }}
                                                  value={
                                                    resTexts[queryObj.query.id] == undefined
                                                      ? ''
                                                      : resTexts[queryObj.query.id]
                                                  }
                                                  onChange={e => handleTextChange(e, queryObj.query.id)}
                                                  onKeyDown={e => {
                                                    e.stopPropagation();
                                                  }}
                                                />
                                                <FormControlLabel
                                                  control={
                                                    <Checkbox
                                                      disabled={queryObj.query.report_is_opened == false}
                                                      checked={respondFieldQueries}
                                                      id="agree"
                                                      onChange={handleRespondAlFieldQueries}
                                                    />
                                                  }
                                                  label="Send Response to all fields in Section Query"
                                                />
                                              </FormControl>
                                              <Button
                                                disabled={
                                                  queryObj.query.report_is_opened == false &&
                                                  queryKeys?.report_category === 'SQREPT' &&
                                                  !checkPermission('view_sq_report_after_submit')
                                                }
                                                onClick={() => {
                                                  if (
                                                    resTexts[queryObj.query.id] != undefined &&
                                                    resTexts[queryObj.query.id] !== ''
                                                  ) {
                                                    sendQueryRes(queryObj.query.id);
                                                  } else {
                                                    const newObj = { ...resTexts };
                                                    newObj[queryObj.query.id] = '';
                                                    setResTexs(newObj);
                                                  }
                                                }}
                                                variant="text"
                                                className={
                                                  queryObj.query.report_is_opened == false ? 'grey-btn-link' : ''
                                                }
                                              >
                                                Send
                                              </Button>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </AccordionDetails>
                                    </Accordion>
                                  </Grid>
                                </Grid>
                              </CardContent>
                            </Card>
                          </Grid>
                        </Grid>
                      );
                    }
                  })
                : null}
            </Box>
          </Grid>
        </Grid>
      )}
      <Grid container spacing={0}>
        <Grid item md={12}>
          <Box sx={{ mb: 2 }}>
            <Grid container>
              <Grid item md={12}>
                <Typography variant="h6" component="div" sx={{ mb: 1 }} className="h6-fs16">
                  Field Queries ({totalFieldQueries})
                </Typography>
              </Grid>
            </Grid>
            {fieldQueries
              ? fieldQueries.map((queryObj: any) => {
                  if (
                    (queryKeys.is_all_field_queries === true &&
                      queryType != 'Field' &&
                      (queryType == 'ALL' || queryType == 'Forward' || queryType == queryObj.query.report_query_type) &&
                      queryObj.query.report_query_type !== 'Section' &&
                      queryObj.query.report_section_name == queryKeys.report_section_name &&
                      queryKeys.section_field_names?.includes(queryObj.query.report_field_name)) ||
                    ((queryType == 'ALL' || queryType == 'Forward' || queryType == queryObj.query.report_query_type) &&
                      queryObj.query.report_query_type !== 'Section' &&
                      queryObj.query.report_section_name == queryKeys.report_section_name &&
                      queryObj.query.report_field_name == queryKeys.report_field_name)
                  ) {
                    return (
                      <Grid container key={queryObj.query.id}>
                        <Grid item md={12}>
                          <Card className="query-card">
                            <CardContent>
                              <Grid container sx={{ pb: 2 }}>
                                <Grid item md={8} className="name-section">
                                  <AccountCircleIcon />
                                  {queryObj.query.created_by}
                                  <span>
                                    {new Date(queryObj.query.created_on)
                                      .toLocaleDateString('en-US', {
                                        hour: 'numeric',
                                        minute: '2-digit',
                                        hour12: true
                                      })
                                      .replace(/,/g, '')}
                                  </span>
                                  <Chip
                                    label={`${queryObj.query.report_query_type} Query`}
                                    color="success"
                                    size="small"
                                  />
                                </Grid>
                                <Grid item md={4} className="more-section" display="flex" justifyContent="flex-end">
                                  <Button
                                    disabled={
                                      queryObj.query.report_is_opened == false ||
                                      !perDisable ||
                                      !(
                                        (queryKeys?.report_category === 'SQREPT' ||
                                          queryKeys?.report_category === 'SUSIVRT') &&
                                        !checkPermission('view_sq_report_after_submit')
                                      )
                                    }
                                    className="grey-btn"
                                    onClick={() => {
                                      (queryKeys?.report_category === 'SQREPT' ||
                                        queryKeys?.report_category === 'SUSIVRT') &&
                                      !checkPermission('view_sq_report_after_submit')
                                        ? setConfirmDailog(true)
                                        : setConfirmDailog(false);
                                      setResloveQueryId(queryObj.query.id);
                                    }}
                                  >
                                    {queryObj.query.report_is_opened == false ? (
                                      <CheckCircleIcon sx={{ fill: '#41B487 !important' }} />
                                    ) : (
                                      <CheckCircleOutlineIcon />
                                    )}
                                  </Button>

                                  <div>
                                    {(queryKeys?.report_category === 'SQREPT' &&
                                      !checkPermission('view_sq_report_after_submit')) ||
                                    checkPermission(
                                      queryKeys?.report_category === 'SQREPT' ||
                                        queryKeys?.report_category === 'SUSIVRT'
                                        ? queryKeys?.report_category === 'SQREPT'
                                          ? 'raise_query_sq_report'
                                          : queryKeys?.report_category === 'SUSIVRT'
                                          ? 'raise_query_siv_report'
                                          : ''
                                        : ''
                                    ) ? (
                                      <Button
                                        disabled={
                                          queryObj.query.report_is_opened == false ||
                                          (queryKeys?.report_category === 'SQREPT' &&
                                            checkPermission('view_sq_report_after_submit'))
                                        }
                                        id="fade-button"
                                        aria-controls={openMore ? 'fade-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={openMore ? 'true' : undefined}
                                        onClick={e => {
                                          setCurrentId(queryObj.query.report_field_query_id_v);
                                          handleClick(e);
                                        }}
                                        className="grey-btn"
                                      >
                                        <MoreHorizIcon />
                                      </Button>
                                    ) : (
                                      <></>
                                    )}
                                    <Menu
                                      id={queryObj.query.report_field_query_id_v}
                                      MenuListProps={{
                                        'aria-labelledby': 'fade-button'
                                      }}
                                      anchorEl={anchorEl}
                                      open={openMore && currentId == queryObj.query.report_field_query_id_v}
                                      onClose={handleCloseMore}
                                      TransitionComponent={Fade}
                                      className="remove-menu"
                                      anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right'
                                      }}
                                      transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right'
                                      }}
                                    >
                                      {(queryKeys?.report_category === 'SQREPT' &&
                                        !checkPermission('view_sq_report_after_submit')) ||
                                      checkPermission(
                                        queryKeys?.report_category === 'SQREPT' ||
                                          queryKeys?.report_category === 'SUSIVRT'
                                          ? queryKeys?.report_category === 'SQREPT'
                                            ? 'delete_query_sq_report'
                                            : queryKeys?.report_category === 'SUSIVRT'
                                            ? 'delete_query_siv_report'
                                            : ''
                                          : ''
                                      ) ? (
                                        <MenuItem
                                          onClick={() => {
                                            setDeleteType('Field');
                                            handleDialoBox(queryObj.query.report_field_query_id_v);
                                          }}
                                        >
                                          <DeleteIcon /> Remove
                                        </MenuItem>
                                      ) : (
                                        <></>
                                      )}
                                      {(queryKeys?.report_category === 'SQREPT' &&
                                        !checkPermission('view_sq_report_after_submit')) ||
                                      checkPermission(
                                        queryKeys?.report_category === 'SQREPT' ||
                                          queryKeys?.report_category === 'SUSIVRT'
                                          ? queryKeys?.report_category === 'SQREPT'
                                            ? 'raise_query_sq_report'
                                            : queryKeys?.report_category === 'SUSIVRT'
                                            ? 'raise_query_siv_report'
                                            : ''
                                          : ''
                                      ) ? (
                                        <MenuItem
                                          onClick={() => {
                                            setQueryType('Forward');
                                            handleForwardDialogBox(
                                              queryObj.query.report_field_query_id_v,
                                              queryObj.query.report_send_to,
                                              queryObj.query.id
                                            );
                                          }}
                                        >
                                          <ForwardIcon />
                                          Forward
                                        </MenuItem>
                                      ) : (
                                        <></>
                                      )}
                                    </Menu>
                                  </div>
                                </Grid>
                                <Grid item md={12}>
                                  <span className="sub-text">ID: {queryObj.query.report_field_query_id_v}</span>
                                  <span className="sub-text">Field: {queryObj.query.report_field_label}</span>
                                  <span className="sub-text">
                                    {queryObj.query.report_forward_to != '' ? 'Initially Sent To' : 'Send To'}:{' '}
                                    {queryObj.query.report_send_to}
                                  </span>
                                  {queryObj.query.report_forward_to != '' && (
                                    <span className="sub-text">Forwarded To: {queryObj.query.report_forward_to}</span>
                                  )}
                                  <span className="sub-text">Message: {queryObj.query.report_comment}</span>
                                </Grid>
                              </Grid>

                              <Grid container>
                                <Grid item md={12}>
                                  <Accordion
                                    expanded={expanded === queryObj.query.report_field_query_id_v}
                                    onChange={handleChangeAccordion(queryObj.query.report_field_query_id_v)}
                                    className="CustomAccordion-AH"
                                  >
                                    {(queryKeys?.report_category === 'SQREPT' &&
                                      !checkPermission('view_sq_report_after_submit')) ||
                                    checkPermission(
                                      queryKeys?.report_category === 'SQREPT' ||
                                        queryKeys?.report_category === 'SUSIVRT'
                                        ? queryKeys?.report_category === 'SQREPT'
                                          ? 'respond_query_sq_report'
                                          : queryKeys?.report_category === 'SUSIVRT'
                                          ? 'respond_query_siv_report'
                                          : ''
                                        : ''
                                    ) ? (
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                      >
                                        <Box>
                                          <Stack spacing={1.5} direction="row" sx={{ alignItems: 'center', mb: 1 }}>
                                            <Typography variant="h6" component="div">
                                              {queryObj.responses && queryObj.responses.length} COMMENT
                                              {queryObj.responses && queryObj.responses.length > 1 ? 'S' : ''}
                                            </Typography>
                                          </Stack>
                                        </Box>
                                      </AccordionSummary>
                                    ) : (
                                      <></>
                                    )}
                                    <AccordionDetails>
                                      <Grid container>
                                        {queryObj.responses &&
                                          queryObj.responses.map((res: any) => {
                                            return (
                                              <div key={res.id}>
                                                <Grid md={12} className="name-section" sx={{ pl: 2 }}>
                                                  <AccountCircleIcon /> {res.created_by}
                                                  <span>
                                                    {new Date(res.created_on)
                                                      .toLocaleDateString('en-US', {
                                                        hour: 'numeric',
                                                        minute: '2-digit',
                                                        hour12: true
                                                      })
                                                      .replace(/,/g, '')}
                                                  </span>
                                                </Grid>
                                                <Grid md={12} sx={{ pl: 2.5, mb: 2, wordBreak: 'break-all' }}>
                                                  <span className="sub-text">{res.query_response}</span>
                                                </Grid>
                                              </div>
                                            );
                                          })}

                                        <Grid container className="action-section">
                                          <Grid md={12}>
                                            <FormControl fullWidth margin="normal" className="response-input">
                                              <TextField
                                                disabled={queryObj.query.report_is_opened == false}
                                                error={resTexts[queryObj.query.id] == ''}
                                                helperText={resTexts[queryObj.query.id] == '' ? 'Required!' : ' '}
                                                id="standard-disabled"
                                                label="Response"
                                                variant="standard"
                                                inputProps={{ maxLength: 200 }}
                                                value={
                                                  resTexts[queryObj.query.id] == undefined
                                                    ? ''
                                                    : resTexts[queryObj.query.id]
                                                }
                                                onChange={e => handleTextChange(e, queryObj.query.id)}
                                                onKeyDown={e => {
                                                  e.stopPropagation();
                                                }}
                                              />
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    disabled={queryObj.query.report_is_opened == false}
                                                    checked={respondSectionQueries}
                                                    id="agree"
                                                    onChange={handleRespondAllSectionQueries}
                                                  />
                                                }
                                                label="Respond to all section queries"
                                              />
                                            </FormControl>
                                            <Button
                                              disabled={queryObj.query.report_is_opened == false}
                                              onClick={() => {
                                                if (
                                                  resTexts[queryObj.query.id] != undefined &&
                                                  resTexts[queryObj.query.id] !== ''
                                                ) {
                                                  sendQueryRes(queryObj.query.id);
                                                } else {
                                                  const newObj = { ...resTexts };
                                                  newObj[queryObj.query.id] = '';
                                                  setResTexs(newObj);
                                                }
                                              }}
                                              variant="text"
                                              className={
                                                queryObj.query.report_is_opened == false ? 'grey-btn-link' : ''
                                              }
                                            >
                                              Send
                                            </Button>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </AccordionDetails>
                                  </Accordion>
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    );
                  }
                })
              : null}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};
